module.exports = __webpack_public_path__ + "202408221624/img/gold_1.ab555985.png";